/**
 This is a proxy for mediatorjs to enable us to
 make it work more strictly for us
 */
'use strict';

var mediatorjs = require('mediatorjs');
var logger = require('loglevel');

var log = logger.getLogger('Mediator');

export class Mediator {

  constructor(mediator) {
    this.mediator = mediator || mediatorjs;
  }

  set(property, value) {
    if (property) {
      log.debug('Mediator set', property, value);
      this.mediator.set.apply(this.mediator, arguments);
    } else {
      throw new Error('No property to set on mediator');
    }
  }

  get(property) {
    if (property) {
      log.debug('Mediator get', property);
      return this.mediator.get.apply(this.mediator, arguments);
    } else {
      throw new Error('No property to get on mediator');
    }
  }

  on(channel, callback) {
    if (channel && callback) {
      this.mediator.on.apply(this.mediator, arguments);
    } else {
      throw new Error('No channel specified to subscribe to');
    }
  }

  once(channel, callback) {
    if (channel && callback) {
      this.mediator.once.apply(this.mediator, arguments);
    } else {
      throw new Error('No channel specified to subscribe to');
    }
  }

  trigger(channel, data) {
    if (channel) {
      log.debug('Mediator triggering', channel, data);
      this.mediator.trigger.apply(this.mediator, arguments);
    } else {
      throw new Error('No channel specified to publish to');
    }
  }

  off(channel) {
    if (channel) {
      this.mediator.off.apply(this.mediator, arguments);
    } else {
      throw new Error('No channel specified to remove');
    }
  }

}

var mediator = new Mediator(mediatorjs);
mediator.Mediator = Mediator;

export default mediator;



// WEBPACK FOOTER //
// ./uikit/mediator.js